import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { type ColumnFiltersState } from "@tanstack/react-table";
import { clientToServerFiltering } from "../../../components/table/utils";
import { useDates } from "../../../dates/DatesContext";
import { useAppSelector } from "../../../redux/hooks";
import { apiClient } from "../../../zodios/client";

type Params = {
  filters?: ColumnFiltersState;
  search?: string;
};

export const useGetV4SearchTermPerformanceTotals = () => {
  const marketPlace = useAppSelector(
    (state: { marketPlace: { marketPlace: string } }) => state.marketPlace.marketPlace,
  );

  const { start, end, preStart, preEnd } = useDates();

  return (params: Params) => {
    const filters = params.filters;
    const search = params.search ? params.search.split(",") : [];

    return queryOptions({
      queryKey: [
        {
          entity: "V4SearchTermPerformanceTotals",
          marketPlace,
          params,
          dates: { start, end, preStart, preEnd },
        },
      ],
      queryFn: async () =>
        await apiClient.getV4SearchTermPerformanceTotals({
          queries: {
            marketplace: marketPlace,
            start_date: start.format("YYYY-MM-DD"),
            end_date: end.format("YYYY-MM-DD"),
            start_date_previous: preStart.format("YYYY-MM-DD"),
            end_date_previous: preEnd.format("YYYY-MM-DD"),
            filters: clientToServerFiltering(filters),
            search: search,
          },
        }),
      placeholderData: keepPreviousData,
    });
  };
};
